import React from "react";
import {connect} from 'react-redux'
import withStyles from "@material-ui/core/styles/withStyles";
import Button from "components/CustomButtons/Button.jsx";
import Close from "@material-ui/icons/Close";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

const styles = {
	modal:{
    position: 'fixed',
    zIndex: '10',
    left: '0',
    top: '0',
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  modalContent: {
    width: '80%',
    maxWidth: '500px',
    border: 'solid 1px gray',
    backgroundColor: 'white',
    padding: '15px',
		paddingLeft: '30px',
  },
  modalHeader:{
    paddingBottom: '20px'
	},
	minWidthSelect:{
		minWidth: '160px'
	}
}
class DefaultProfileModal extends React.Component {
		state = {
			selectedProfileType: -1,
			defaultProfile: -1,
			disableNext: true
		}
    componentWillMount(){
      
    }
    
    close(){
      this.props.close()
    }
    save(){
			const {selectedProfileType, defaultProfile} = this.state
      this.props.save(selectedProfileType, defaultProfile)
		}
		profileTypeChange(e){
			//console.log()
			if(e.target.value === 'BASED'){
				this.setState({selectedProfileType: e.target.value, disableNext: true})
			} else {
				this.setState({selectedProfileType: e.target.value, disableNext: false})
			}
		}
		defaultProfileChange(e){
			this.setState({defaultProfile: e.target.value, disableNext: false})
		}
    render() {
			const {classes, profiles} = this.props
			const {selectedProfileType, defaultProfile} = this.state
			const profileTypes = [
				{value: 'NEW', label: 'New Profile'},
				{value: 'DEFAULT', label:'Default'},
				{value: 'BASED', label: 'Based on Default'}
			]
      return (
        <div className={classes.modal}>
          <div className={classes.modalContent}>
            <div className={classes.modalHeader}>
              <span style={{fontSize: '16px'}}>Profile Type</span>
              <Close onClick={() => this.close()} style={{fontSize: '16px', color: 'gray', float: 'right', cursor: 'pointer'}} />
            </div>
            <div style={{paddingBottom: '20px', minHeight: '200px'}}>
							
							<Select
								value={selectedProfileType}
								MenuProps={{
									className: classes.selectMenu
								}}
								classes={{
									select: classes.select + ' ' + classes.minWidthSelect
								}}

								inputProps={{
									onChange: this.profileTypeChange.bind(this),
									id: "selectedProfileType",
									name: "selectedProfileType"
								}}>
									<MenuItem
										key={-1}
										disabled={true}
										classes={{
											root: classes.selectMenuItem
										}}
										value={-1}>
										{'Choose Profile Type'}
									</MenuItem>
									{profileTypes
										.map((e) => (
											<MenuItem
												key={e.value}
												classes={{
													root: classes.selectMenuItem
												}}
												value={e.value}>
												{e.label}
											</MenuItem>
									))}
							</Select>

							{this.state.selectedProfileType === 'BASED' && (
								<div style={{marginTop: '25px'}}>
									<Select
										value={defaultProfile}
										MenuProps={{
											className: classes.selectMenu
										}}
										classes={{
											select: classes.select + ' ' + classes.minWidthSelect
										}}

										inputProps={{
											onChange: this.defaultProfileChange.bind(this),
											id: "defaultProfile",
											name: "defaultProfile"
										}}>
											<MenuItem
												key={-1}
												disabled={true}
												classes={{
													root: classes.selectMenuItem
												}}
												value={-1}>
												{'Select Profile'}
											</MenuItem>
											{profiles
												.map((e) => (
													<MenuItem
														key={e.profileId}
														classes={{
															root: classes.selectMenuItem
														}}
														value={e.profileId}>
														{e.name}
													</MenuItem>
											))}
									</Select>
								</div>
							)}
            </div>

            <div style={{paddingTop:'15px',textAlign: 'right'}}>
              <Button
								color="danger"
                type="button"
                onClick={()=> this.close()}
							>
								Cancel
							</Button>
              <Button
								color="success"
								type="button"
								disabled={this.state.disableNext}
                onClick={()=> this.save()}
								style={{marginLeft: '20px'}}
							>
								Next
							</Button>
            </div>
          </div>
        </div>
      )
    }
}

export default withStyles({...styles})(connect(null,null)(DefaultProfileModal));



// WEBPACK FOOTER //
// ./src/views/Profiles/DefaultProfileModal.jsx